/* eslint-disable no-tabs */
<template>
  <div class="movie">
    <div>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="create">创建</el-button>
      <el-radio-group v-model="play_type" @change="playTypeChange" size="small" style="margin-left:10px;">
        <el-radio-button :label="1">即买即看</el-radio-button>
        <el-radio-button :label="0">按场次</el-radio-button>
        <el-radio-button :label="2">免费</el-radio-button>
      </el-radio-group>

      <el-radio-group v-model="audit_status" @change="playTypeChange" size="small" style="margin-left:10px;">
        <el-radio-button :label="1">已审核</el-radio-button>
        <el-radio-button :label="0">待审核</el-radio-button>
      </el-radio-group>

      <el-input v-model="key" size="small" style="margin-left: 20px; width: 200px;" placeholder="搜索"></el-input>
      <el-button style="margin-left: 10px; " type="primary" size="small" @click="getList">刷新</el-button>
    </div>
    <el-table :data="list" style="width: 100%" class="table">
      <el-table-column label="电影" width="360">
        <template slot-scope="scope">
          <div class="movie-item">
            <img class="movie-thumb" :src="scope.row.thumb  + '?imageView2/2/w/200|imageslim'">
            <div class="movie-info">
              <p class="movie-title"><span>《{{scope.row.title}}</span>》</p>
              <p class="movie-grade">
                <span>{{scope.row.grade||0}}分</span>
                <span style="margin-left: 10px">{{scope.row.year}}年</span>
                导演：<span v-for="(item,index) in scope.row.directors" :key="item">
                  {{item}}
                  <template v-if="index < scope.row.directors.length - 1">、</template>
                </span>
              </p>
              <p>
                机构:
                <span v-if="scope.row.partner">
                  {{scope.row.partner.title}}
                </span>
                <span v-else>
                  无
                </span>
                <el-button type="text" size="small" icon="el-icon-edit" @click="handleEditPartnerId(scope.row)">设置</el-button>
              </p>

              <el-switch
                :active-value="0"
                :inactive-value="1"
                v-model="scope.row.is_hidden"
                @change="change($event, scope.row)">
              </el-switch>

              <!-- <span>保底点赞: {{scope.row.base_agree || 0}}</span> -->

            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="统计" width="120">
        <template slot-scope="scope">
          <div>点赞: {{scope.row.like_count || 0}}</div>
          <div>播放: {{scope.row.play_count || 0}}</div>
          <div>浏览: {{scope.row.visit_count || 0}}</div>
        </template>
      </el-table-column>

      <el-table-column label="定价" width="80" v-if="play_type!==2">
        <template slot-scope="scope">
          <p>{{scope.row.price/100}}元</p>
        </template>
      </el-table-column>
      <el-table-column label="放映场次" width="100" v-if="play_type===0">
        <template slot-scope="scope">
          <el-button size="small" type="text" @click="showSession(scope.row)" v-if="scope.row.sessions.length">{{scope.row.sessions.length}}场</el-button>
          <el-button @click="addSession(scope.row)" size="mini" type="text">添加</el-button>
        </template>
      </el-table-column>
      <el-table-column label="权重" width="80">
        <template slot-scope="scope">
          <p>
            <span>{{scope.row.weight}}</span>
            <el-button size="small" type="text" icon="el-icon-edit" @click="setWeight(scope.row)"></el-button>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="观影上限" width="150" v-if="play_type===2">
        <template slot-scope="scope">
          <p>
            <span v-if="scope.row.limit_people">{{scope.row.limit_people}}</span>
            <el-button size="small" type="text" icon="el-icon-edit" @click="setPlayPeople(scope.row)"></el-button>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="购买文字提示" width="200">
        <template slot-scope="scope">
          <div>
            屏幕:
            <el-button type="text" @click="setScreenText(scope.row)" icon="el-icon-edit">
              {{scope.row.buy_screen_text}}
            </el-button>
          </div>
          <div>
            按钮:
            <el-button type="text" @click="setButtonText(scope.row)" icon="el-icon-edit">{{scope.row.buy_btn_text}}</el-button>
            <el-switch
              :active-value="1"
              :inactive-value="0"
              v-model="scope.row.is_show_buy_btn"
              @change="change4($event, scope.row)">
            </el-switch>
          </div>

        </template>
      </el-table-column>
      <!-- <el-table-column label="购买文字" width="160">
        <template slot-scope="scope">
          <el-button type="text" @click="setButtonText(scope.row)" icon="el-icon-edit">{{scope.row.buy_btn_text}}</el-button>
          <el-switch
            :active-value="1"
            :inactive-value="0"
            v-model="scope.row.is_show_buy_btn"
            @change="change4($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="显示/隐藏" width="150">
        <template slot-scope="scope">
          <el-switch
            :active-value="0"
            :inactive-value="1"
            v-model="scope.row.is_hidden"
            @change="change($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column> -->
      <el-table-column label="海报与分享" width="160">
        <template slot-scope="scope">
          <div>
            海报:
            <el-button type="text" icon="el-icon-edit" @click="showSharePoster(scope.row)">{{scope.row.share_title?"已设置":""}}</el-button>
          </div>
          <div>
            禁止分享:
            <el-switch
            :active-value="1"
            :inactive-value="0"
            v-model="scope.row.is_ban_share"
            @change="sharechange($event, scope.row)">
          </el-switch>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="禁止分享" width="150">
        <template slot-scope="scope">
          <el-switch
            :active-value="1"
            :inactive-value="0"
            v-model="scope.row.is_ban_share"
            @change="sharechange($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div>
            <el-button type="text" size="small" @click="changeToType(scope.row, 2)" v-if="scope.row.play_type !== 2">转为免费</el-button>
            <el-button type="text" size="small" @click="changeToType(scope.row, 0)" v-if="scope.row.play_type !== 0">转为按场次</el-button>
            <el-button type="text" size="small" @click="changeToType(scope.row, 1)" v-if="scope.row.play_type !== 1">转为即买即看</el-button>

            <!-- <el-button type="text" size="small" @click="change3(scope.row.play_type, scope.row)" v-if="play_type!==2">{{scope.row.play_type===1?'转为按场次':'转为即买即看'}}</el-button>
            <el-button type="text" size="small" @click="change2(scope.row.is_free, scope.row)" v-if="scope.row.play_type === 0">{{scope.row.is_free===1?'转为收费':'转为免费'}}</el-button> -->
          </div>
          <div>
            <el-button type="text" size="small" v-if="scope.row.audit_status === 0" @click="auditAccept(scope.row)">通过审核</el-button>
            <el-button type="text" size="small" @click="showAppPath(scope.row)">路径</el-button>
            <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="[5, 10, 15, 20]" :page-size="per_page" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
    <el-dialog :title="action===0?'创建':'编辑'" :visible.sync="dialogVisible" width="900px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="封面" prop="thumb">
          <img v-if="form.thumb" class="thumb cursor-pointer" :src="form.thumb" title="点击更换" @click="selectThumb('thumb')">
          <div v-else class="addimg" @click="selectThumb('thumb')">+</div>
        </el-form-item>
        <el-form-item label="背景图" prop="bg_image">
          <img v-if="form.bg_image" class="thumb cursor-pointer" :src="form.bg_image" title="点击更换" @click="selectThumb('bg_image')">
          <div v-else class="addimg" @click="selectThumb('bg_image')">+</div>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="名字" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="标题(英文)" prop="title">
          <el-input v-model="form.title_en" placeholder="名字" style="width: 400px"></el-input>
        </el-form-item>

        <el-form-item label="所属机构" prop="title">
          <el-select v-model="form.partner_id" placeholder="请选择" style="width:300px">
             <el-option :value="partner.id" :label="partner.title" v-for="partner in partnerList">{{partner.title}}</el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属专题/展映" prop="title">
          <el-select v-model="form.album_type" placeholder="请选择" style="width:120px">
            <el-option label="专题" value="topic"></el-option>
            <el-option label="展映" value="track"></el-option>
          </el-select>

          <el-select v-if="form.album_type === 'topic'" v-model="form.album_id" placeholder="请选择" style="width:400px">
            <el-option
              v-for="item in topicList"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
          <el-select v-else v-model="form.album_id" placeholder="请选择" style="width:400px">
            <el-option
              v-for="item in trackList"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <template v-if="!isTenant">
          <el-form-item label="点赞数">
             <el-input v-model="form.like_count" placeholder="设置点赞数" style="width: 600px"></el-input>
          </el-form-item>
          <el-form-item label="播放数">
             <el-input v-model="form.play_count" placeholder="设置播放数" style="width: 600px"></el-input>
          </el-form-item>
          <el-form-item label="浏览数">
             <el-input v-model="form.visit_count" placeholder="设置浏览数" style="width: 600px"></el-input>
          </el-form-item>
        </template>

        <el-form-item label="语言" prop="language">
          <el-input v-model="form.language" placeholder="语言" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="语言(英文)" prop="language">
          <el-input v-model="form.language_en" placeholder="语言" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="国别" prop="country">
          <el-input v-model="form.country" placeholder="国别" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="国别(英文)" prop="country">
          <el-input v-model="form.country_en" placeholder="国别" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="发布时间" prop="published_at">
          <el-date-picker
            v-model="form.published_at"
            type="date"
            placeholder="发布时间"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="导演" prop="directors">
          <tag-input v-model="form.directors"></tag-input>
        </el-form-item>
        <el-form-item label="导演(英文)" prop="directors_en">
          <tag-input v-model="form.directors_en"></tag-input>
        </el-form-item>
        <el-form-item label="主演" prop="protagonists">
          <tag-input v-model="form.protagonists"></tag-input>
        </el-form-item>
        <el-form-item label="主演(英文)" prop="protagonists_en">
          <tag-input v-model="form.protagonists_en"></tag-input>
        </el-form-item>
        <el-form-item label="艺术家">
          <el-select v-model="form.related_artists" multiple placeholder="请选择" style="width:400px">
            <el-option
              v-for="item in artists"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="form.tag_ids" multiple placeholder="请选择" style="width:400px">
            <el-option
              v-for="item in category"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预告片" prop="prevue">
          <el-input v-model="form.prevue" placeholder="视频网络资源" style="width: 600px"></el-input>
        </el-form-item>
        <el-form-item label="视频链接" prop="src">
          <UploadVideo v-model="form.src"></UploadVideo>
          <!-- <el-input v-model="form.src" placeholder="视频网络资源" style="width: 600px"></el-input> -->
        </el-form-item>
        <!-- <el-form-item label="视频时长(秒)" prop="src">
          <el-input v-model="form.duration" placeholder="视频时长" style="width: 600px"></el-input>
        </el-form-item>
        <el-form-item label="视频文件大小" prop="src">
          <el-input v-model="form.size" placeholder="视频文件大小（1M请填写1000）" style="width: 600px"></el-input>
        </el-form-item> -->
        <el-form-item label="年份" prop="year">
          <el-input v-model.number="form.year" placeholder="年份" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="评分" prop="grade">
          <el-input v-model="form.grade" placeholder="评分" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="定价" prop="price">
          <el-input v-model="form.price" placeholder="定价" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" autosize v-model="form.description" placeholder="描述"></el-input>
        </el-form-item>
        <el-form-item label="描述(英文)" prop="description">
          <el-input type="textarea" autosize v-model="form.description_en" placeholder="描述"></el-input>
        </el-form-item>
        <el-form-item label="无场次文字" prop="description">
          <el-input autosize v-model="form.empty_text_1" placeholder="默认为:无场次"></el-input>
        </el-form-item>
        <el-form-item label="无场次文字(英文)" prop="description">
          <el-input autosize v-model="form.empty_text_1_en" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="售罄文字" prop="description">
          <el-input autosize v-model="form.empty_text_2" placeholder="默认为:售罄"></el-input>
        </el-form-item>
        <el-form-item label="售罄文字(英文)" prop="description">
          <el-input autosize v-model="form.empty_text_2_en" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="相关视频" prop="related_videos">
          <el-row class="related-videos" v-for="(item,index) in form.related_videos" :key="item.title">
            <el-form label-width="60px">
              <el-form-item label="封面">
                <img v-if="item.thumb" class="thumb cursor-pointer" :src="item.thumb" title="点击更换" @click="selectThumb1(index)">
                <div v-else class="addimg" @click="selectThumb1(index)">+</div>
              </el-form-item>
              <el-form-item label="标题">
                <el-input v-model="item.title" placeholder="标题" style="width: 320px"></el-input>
              </el-form-item>
              <el-form-item label="视频">
                <UploadVideo v-model="item.video"></UploadVideo>
                <!-- <el-input v-model="item.video" placeholder="视频资源" style="width: 500px"></el-input> -->
              </el-form-item>
            </el-form>
            <div class="btn-g">
              <i class="el-icon-delete cursor-pointer" @click="deleteVideo(index)"></i>
            </div>
          </el-row>
          <el-button size="small" @click="addVideo(0)">添加视频</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-show="action===0" type="primary" @click="submit">确 定</el-button>
        <el-button v-show="action===1" type="primary" @click="saveChange">保存更改</el-button>
      </span>
    </el-dialog>
    <el-dialog title="创建场次" :visible.sync="dialogVisible2" width="800px">
      <div class="session">
        <el-form class="session-form" label-position="left" label-width="80px" size="mini">
          <el-form-item label="选择日期">
            <el-date-picker
              type="dates"
              v-model="days"
              placeholder="选择一个或多个日期"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <div style="display:flex;margin-bottom:5px;align-items:center;" v-for="(item,index) in sessions" :key="index">
            <p>{{index+1}}.</p>
            <div class="label" style="width:70px;">时间</div>
            <el-input placeholder="格式 09:30" v-model="item.time" size="mini" style="width:140px;margin-right:10px;"></el-input>
            <div class="label" style="width:80px;">观看人数</div>
            <el-input v-model="item.people_limit" placeholder="观看人数" size="mini" style="width:140px;margin-right:10px;"></el-input>
            <el-button type="text" @click="sessionAddItem(index)" size="mini">添加</el-button>
            <el-button type="text" @click="sessionDeleteItem(index)" size="mini">删除</el-button>
          </div>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitSessions">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="放映场次" :visible.sync="dialogVisible3" width="800px">
      <el-table :data="current.session_by_day" class="table" center>
        <el-table-column type="expand">
          <template slot-scope="props">
             <el-table :data="props.row.list" class="table" center>
                <el-table-column
                  type="index"
                  width="50">
                </el-table-column>
                <el-table-column prop="people_limit" label="限制人数" width="150"></el-table-column>
                <el-table-column prop="sales" label="已出售" width="150"></el-table-column>
                <el-table-column prop="start_at" label="开始时间">
                  <template slot-scope="scope">
                    <span>{{format(scope.row.start_at)}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="sessionDeleteItem2(scope.row, scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
             </el-table>
          </template>
        </el-table-column>
        <el-table-column label="日期">
          <template slot-scope="scope">
            {{scope.row.day}}
          </template>
        </el-table-column>
        <el-table-column label="场次">
          <template slot-scope="scope">
            {{scope.row.list.length}}场
          </template>
        </el-table-column>
        <el-table-column label="销量">
          <template slot-scope="scope">
            {{scope.row.sales}}
          </template>
        </el-table-column>
        <el-table-column label="库存">
          <template slot-scope="scope">
            {{scope.row.stock}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="sessionDeleteItemByDay(scope.row, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="addSession(current)">添加场次</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible4" title="路径" center width="800px">
      <el-form label-width="80px">
        <el-form-item label="小程序">
          <el-input :value="miniAppPath">
          </el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="绑定机构" :visible.sync="setPartnerVisible" width="600px">
      <div class="poster">
        <el-form class="poster-form" label-position="left" label-width="80px" size="mini">
          <el-form-item label="选择机构">
            <el-select style="width:280px" v-model="partnerId">
              <el-option :value.number="partner.id" :label="partner.title" v-for="partner in partnerList">{{partner.title}}</el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="setPartnerVisible = false">取 消</el-button>
        <el-button type="primary" @click="setPartnerId">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="海报设置" :visible.sync="ShareSettingsVisible" width="600px">
      <div class="poster">
        <el-form class="poster-form" label-position="left" label-width="80px" size="mini">
          <el-form-item label="标题">
            <el-input placeholder="请输入" v-model="shareForm.share_title" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="日期">
            <el-input placeholder="请输入" v-model="shareForm.share_date" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="二维码">
            <img v-if="shareForm.share_qrcode" class="thumb cursor-pointer" :src="shareForm.share_qrcode" title="点击更换" @click="selectShareQrcode('share_qrcode')">
            <div v-else class="addimg" @click="selectShareQrcode('share_qrcode')">+</div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="ShareSettingsVisible = false">取 消</el-button>
        <el-button type="primary" @click="postShareSettings">确 定</el-button>
      </span>
    </el-dialog>
    <upload-img ref="upload" tips-width="900" tips-height="900"></upload-img>
  </div>
</template>
<script>
import request from '@/utils/request'
import UploadImg from '@/components/UploadImg'
import UploadVideo from '@/components/UploadVideo/index'
import TagInput from '@/components/TagInput'
export default {
  components: {
    UploadImg,
    TagInput,
    UploadVideo
  },
  props: {
    type: {
      default () {
        return 'platform'
      }
    }
  },
  data () {
    var validateThumb = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择封面'))
      } else {
        callback()
      }
    }
    var validateNumber = (rule, value, callback) => {
      if (!/^\d+(\.\d+)?$/.test(value)) {
        callback(new Error('请输入数字'))
      } else {
        callback()
      }
    }
    return {
      isTenant: 0,
      audit_status: 1,
      action: 0,
      list: [],
      setPartnerVisible: false,
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      miniAppPath: '',
      days: [],
      sessions: [],
      page: 1,
      key: '',
      per_page: 5,
      total: 0,
      current: {},
      artists: [],
      category: [],
      isFirst: true,
      partnerId: null,
      form: {
        thumb: '',
        bg_image: '',
        like_count: 0,
        visit_count: 0,
        play_count: 0,
        title: '',
        title_en: '',
        directors: [],
        directors_en: [],
        protagonists: [],
        protagonists_en: [],
        related_artists: [],
        tag_ids: [],
        duration: 0,
        size: 0,
        src: '',
        year: '',
        grade: '',
        price: '',
        description: '',
        description_en: '',
        empty_text_1: '',
        empty_text_1_en: '',
        empty_text_2: '',
        empty_text_2_en: '',
        prevue: '',
        related_videos: [],
        language: '',
        language_en: '',
        country: '',
        country_en: '',
        published_at: '',
        album_id: null,
        album_type: 'topic'
      },
      play_type: 1,
      rules: {
        title: [
          { required: true, message: '标题', trigger: 'blur' }
        ],
        src: [
          { required: true, message: '请输入视频网络资源', trigger: 'blur' }
        ],
        year: [
          { type: 'number', message: '请输入年份（数字）', trigger: 'blur' }
        ],
        grade: [
          { validator: validateNumber, trigger: 'blur' }
        ],
        price: [
          { validator: validateNumber, trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ],
        empty_text_1: [
        ],
        empty_text_2: [
        ],
        thumb: [
          { validator: validateThumb, trigger: 'blur' }
        ]
      },
      ShareSettingsVisible: false,
      shareForm: {
        share_title: '',
        share_date: '',
        share_qrcode: ''
      },
      trackList: [],
      topicList: [],
      partnerList: []
    }
  },
  watch: {
    $route () {
      this.getList()
    },
    key () {
      this.page = 1
      this.getList()
    },
    audit_status () {
      this.page = 1
      this.getList()
    }
  },
  created () {
    this.getList()
    this.getArtits()
    this.getCategory()
    this.getPartnerList()

    console.log(this.type)

    request({
      url: '/movie/articles',
      params: {
        type: 'movie_panorama',
        per_page: 200,
      }
    }).then(res => {
      this.trackList = res.data.list
    })

    request({
      url: '/movie/topics',
      params: {
        per_page: 200,
      }
    }).then(res => {
      this.topicList = res.data.list
    })
  },
  methods: {
    setPartnerId () {
      request({
        url: '/movie/' + this.current.uuid,
        method: 'patch',
        data: {
          type: 'update',
          attributes: {
            partner_id: this.partnerId
          }
        }
      }).then(res => {
        this.$message.success('保存成功!')
        this.setPartnerVisible = false
        this.getList()
      })
    },
    postShareSettings () {
      request({
        url: '/movie/' + this.current.uuid,
        method: 'patch',
        data: {
          type: 'update',
          attributes: this.shareForm
        }
      }).then(res => {
        this.$message.success('保存成功!')
        this.ShareSettingsVisible = false
        this.getList()
      })
    },
    showSharePoster (row) {
      this.current = row
      this.shareForm = {
        share_title: row.share_title,
        share_date: row.share_date,
        share_qrcode: row.share_qrcode
      }
      this.ShareSettingsVisible = true
    },
    selectShareQrcode () {
      let list = []
      if (this.shareForm.share_qrcode) {
        list = [this.shareForm.share_qrcode]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.shareForm.share_qrcode = res[0]
        } else {
          this.shareForm.share_qrcode = ''
        }
      }).catch()
    },
    sessionDeleteItemByDay (row, index) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/session-batch-delete',
          method: 'post',
          data: {
            day: row.day,
            movie_id: this.current.id
          }
        }).then(() => {
          this.current.session_by_day.splice(index, 1)
        }).catch()
      }).catch()
    },
    setScreenText (row) {
      this.$prompt('请输入电影屏幕上购买文字', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.buy_screen_text || ''
      }).then(({ value }) => {
        request({
          url: '/movie/' + row.uuid,
          method: 'patch',
          data: {
            type: 'update_buy_screen_text',
            buy_screen_text: value
          }
        }).then(() => {
          this.getList()
        })
      }).catch(() => {})
    },
    setButtonText (row) {
      this.$prompt('请输入按钮文字', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.buy_btn_text || ''
      }).then(({ value }) => {
        request({
          url: '/movie/' + row.uuid,
          method: 'patch',
          data: {
            type: 'update_buy_btn_text',
            buy_btn_text: value
          }
        }).then(() => {
          this.getList()
        })
      }).catch(() => {})
    },
    playTypeChange (e) {
      this.page = 1
      this.getList()
    },
    showAppPath (row) {
      this.current = JSON.parse(JSON.stringify(row))
      this.miniAppPath = 'pages/movieDetail/index?uuid=' + this.current.uuid
      this.dialogVisible4 = true
    },
    format (date) {
      if (date) {
        return date.substr(5, 11)
      } else {
        return ''
      }
    },
    handleEditPartnerId (row) {
      this.current = row
      this.partnerId = row.partner_id
      this.setPartnerVisible = true
    },
    setWeight (row) {
      this.$prompt('请输入', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        request({
          url: '/movie/' + row.uuid,
          method: 'patch',
          data: {
            type: 'update_weight',
            weight: value
          }
        }).then(() => {
          this.getList()
        })
      }).catch(() => {})
    },
    auditAccept (row) {
      request({
        url: '/movie/' + row.uuid,
        method: 'patch',
        data: {
          type: 'audit_accept',
        }
      }).then(() => {
        this.$message.success('审核成功!')
        this.getList()
      })
    },
    getList () {
      request({
        url: '/movie',
        params: {
          platform_type: this.type,
          per_page: this.per_page,
          page: this.page,
          play_type: this.play_type,
          key: this.key,
          audit_status: this.audit_status
        }
      }).then(res => {
        this.list = res.data.list
        this.total = res.data.item_total
      })
    },
    getPartnerList () {
      request({
        url: '/partners',
      }).then(res => {
        this.partnerList = res.data.list
        this.partnerList.unshift({
          'id': null,
          'title': '不绑定机构'
        })
      })
    },
    getArtits () {
      request({
        url: '/movie/people?type=artist'
      }).then(res => {
        this.artists = res.data.list
      })
    },
    getCategory () {
      request({
        url: '/movie/tags'
      }).then(res => {
        this.category = res.data.list
      })
    },
    handleSizeChange (e) {
      this.per_page = e
      this.handleCurrentChange(1)
    },
    handleCurrentChange (e) {
      this.page = e
      this.getList()
    },
    create () {
      this.action = 0
      this.dialogVisible = true
      this.$nextTick(() => {
        if (!this.isFirst) {
          this.resetForm()
        }
        this.isFirst = false
      })
    },
    editItem (row) {
      request({
        url: '/movie/' + row.uuid
      }).then(res => {
        this.current = res.data.movie
        this.startEditItem()
      })
    },
    startEditItem () {
      // this.current = JSON.parse(JSON.stringify(row))
      let row = this.current

      this.action = 1
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
        this.form = {
          thumb: row.thumb,
          bg_image: row.bg_image,
          title: row.title,
          title_en: row.title_en,
          directors: JSON.parse(JSON.stringify(row.directors)),
          directors_en: JSON.parse(JSON.stringify(row.directors_en)),
          protagonists: JSON.parse(JSON.stringify(row.protagonists)),
          protagonists_en: JSON.parse(JSON.stringify(row.protagonists_en)),
          related_artists: JSON.parse(JSON.stringify(row.related_artists)) || [],
          tag_ids: JSON.parse(JSON.stringify(row.tag_ids)) || [],
          src: row.src,
          year: row.year,
          grade: row.grade,
          size: row.size,
          duration: row.duration,
          price: row.price / 100,
          description: row.description,
          description_en: row.description_en,
          empty_text_2: row.empty_text_2,
          empty_text_2_en: row.empty_text_2_en,
          empty_text_1: row.empty_text_1,
          empty_text_1_en: row.empty_text_1_en,
          prevue: row.prevue,
          like_count: row.like_count,
          visit_count: row.visit_count,
          play_count: row.play_count,
          related_videos: JSON.parse(JSON.stringify(row.related_videos)),
          language: row.language,
          language_en: row.language_en,
          country: row.country,
          country_en: row.country_en,
          partner_id: row.partner_id,
          published_at: row.published_at,
          album_type: row.album_type,
          album_id: row.album_id
        }
      })
      // console.log(row)
    },
    selectThumb (key) {
      let list = []
      if (this.form[key]) {
        list = [this.form[key]]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.form[key] = res[0]
        }
      }).catch()
    },
    selectThumb1 (index) {
      let list = []
      if (this.form.related_videos[index].thumb) {
        list = [this.form.thumb]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.form.related_videos[index].thumb = res[0]
        }
      }).catch()
    },
    addVideo (index) {
      this.form.related_videos.splice(index, 0, {
        thumb: '',
        video: '',
        title: ''
      })
    },
    deleteVideo (index) {
      this.form.related_videos.splice(index, 1)
    },
    submit () {
      let sendData = JSON.parse(JSON.stringify(this.form))
      sendData.price = parseFloat(sendData.price) * 100
      request({
        url: '/movie',
        method: 'post',
        data: sendData
      }).then(res => {
        this.$message.success('创建成功!')
        this.dialogVisible = false
        this.handleCurrentChange(1)
        this.resetForm()
      })
    },
    saveChange () {
      let sendData = JSON.parse(JSON.stringify(this.form))
      sendData.price = parseFloat(sendData.price) * 100
      request({
        url: '/movie/' + this.current.uuid,
        method: 'patch',
        data: {
          type: 'update',
          attributes: sendData
        }
      }).then(res => {
        this.$message.success('保存成功!')
        this.dialogVisible = false
        this.getList()
        this.resetForm()
      })
    },
    resetForm () {
      this.form = {
        thumb: '',
        bg_image: '',
        title: '',
        title_en: '',
        directors: [],
        directors_en: [],
        protagonists: [],
        protagonists_en: [],
        related_artists: [],
        tag_ids: [],
        src: '',
        year: '',
        size: '',
        duration: '',
        grade: '',
        price: '',
        like_count: 0,
        visit_count: 0,
        play_count: 0,
        description: '',
        empty_text_1: '',
        empty_text_2: '',
        description_en: '',
        empty_text_1_en: '',
        empty_text_2_en: '',
        related_videos: []
      }
      this.$refs['form'].resetFields()
    },
    deleteItem (row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/movie/' + row.uuid,
          method: 'delete'
        }).then(res => {
          this.$message.success('删除成功!')
          this.getList()
        })
      }).catch()
    },
    changeToType (row, type) {
      request({
        url: '/movie/' + row.uuid,
        method: 'patch',
        data: {
          // type: e ? 'free' : 'cancel_free'
          type: 'update_play_type',
          play_type: type
        }
      }).then(() => {
        this.getList()
      }).catch(() => {
        this.getList()
      })
    },
    change2 (e, row) {
      request({
        url: '/movie/' + row.uuid,
        method: 'patch',
        data: {
          // type: e ? 'free' : 'cancel_free'
          type: e ? 'cancel_free' : 'free'
        }
      }).then(() => {
        this.getList()
      }).catch(() => {
        this.getList()
      })
    },
    change (e, row) {
      request({
        url: '/movie/' + row.uuid,
        method: 'patch',
        data: {
          type: e ? 'hide' : 'show'
        }
      }).then(() => {}).catch(() => {
        this.getList()
      })
    },
    change3 (e, row) {
      request({
        url: '/movie/' + row.uuid,
        method: 'patch',
        data: {
          type: 'update_play_type',
          play_type: e ? 0 : 1
        }
      }).then(() => {
        this.getList()
      }).catch(() => {
        this.getList()
      })
    },
    change4 (e, row) {
      request({
        url: '/movie/' + row.uuid,
        method: 'patch',
        data: {
          type: e ? 'show_buy_btn' : 'hide_buy_btn'
        }
      }).then(() => {
        this.getList()
      }).catch(() => {
        this.getList()
      })
    },
    sharechange (e, row) {
      request({
        url: '/movie/' + row.uuid,
        method: 'patch',
        data: {
          type: e ? 'ban_share' : 'cancel_ban_share'
        }
      }).then(() => {}).catch(() => {
        this.getList()
      })
    },
    setPlayPeople (row) {
      this.$prompt('请输入在线观影人数', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        request({
          url: '/movie/' + row.uuid,
          method: 'patch',
          data: {
            type: 'update',
            attributes: {
              limit_people: value
            }
          }
        }).then(() => {
          this.getList()
        })
      }).catch(() => {})
    },
    addSession (row) {
      this.current = JSON.parse(JSON.stringify(row))
      this.days = []
      this.sessions = []
      this.sessions.push({
        time: '',
        people_limit: ''
        // price: ''
      })
      this.dialogVisible2 = true
    },
    sessionAddItem (index) {
      this.sessions.splice(index + 1, 0, {
        time: '',
        people_limit: ''
        // price: ''
      })
    },
    sessionDeleteItem (index) {
      this.sessions.splice(index, 1)
    },
    sessionDeleteItem2 (row, index) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/movie/sessions/' + row.uuid,
          method: 'delete'
        }).then(() => {
          this.current.sessions.splice(index, 1)
        }).catch()
      }).catch()
    },
    submitSessions () {
      request({
        url: '/movie/sessions',
        method: 'post',
        data: {
          movie_id: this.current.id,
          sessions: {
            days: this.days,
            list: this.sessions
          }
        }
      }).then(() => {
        this.getList()
        this.dialogVisible2 = false
        this.dialogVisible3 = false
      }).catch()
    },
    showSession (row) {
      this.current = row
      this.dialogVisible3 = true
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-form-item {
  margin-bottom: 20px!important;
}
.movie-item {
  display: flex;
  .movie-thumb {
    height: 80px;
    width: 52px;
  }
  .movie-info {
    margin-left: 10px;
    p {
      margin-bottom: 0;
      line-height: 20px;
      font-size: 13px;
    }
    .movie-title {
      font-weight: bold;
      color: #111;
      font-weight: 15px;
    }
  }
}
.table {
  border: 1px solid #ebeef5;
  border-bottom: none;
  margin-top: 10px;
}
.pager {
  margin: 15px 0;
}
.addimg {
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #666;
  font-size: 17px;
  border: 1px dashed #999999;
  cursor: pointer;
}
.thumb {
  height: 50px;
  width: auto;
}
.tag {
  margin-right: 5px;
}
.input-new-tag {
  width: 100px;
}
.related-videos {
  position: relative;
  padding: 10px 0;
  margin-bottom: 15px;
  background-color: #efefef;
  .btn-g {
    position: absolute;
    top: 5px;
    right: 10px;
    i {
      font-size: 20px;
      margin-left: 5px;
    }
  }
}
.session {
  h3 {
    margin-bottom: 7px;
    color: #222222;
    font-size: 16px;
  }
  /deep/ .el-form-item {
    margin-bottom: 10px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/movie/movie.vue